import React, { useContext } from 'react';
import UserProvider from '../../context/UserContext';
import { CardExitConfirmation } from '../card/CardExitConfirmation';
import { CardHowItWorks } from '../card/CardHowItWorks';

export const MainSuccess = () => {

    const Context = useContext(UserProvider.context);

    const handleHowItWorks = () => {
        Context.setshowHowItWorks(!Context.showHowItWorks)
    }

    const handleExitWaitlist = () => {
        Context.setExitWaitlist(!Context.showExitWaitlist)
    }

    return(

        <div className="center-container-holder">
            <div className="centered-container">
                {
                    Context.showExitWaitlist &&
                    
                    <div className="center-holder">
                        <CardExitConfirmation/>
                    </div>   
                }
                {             
                    Context.showHowItWorks &&

                    <div className="center-holder">
                        <CardHowItWorks/>
                    </div>                      
                }
                {
                    !Context.showHowItWorks &&
                    !Context.showExitWaitlist &&

                    <div className="center-holder">
                        <div className="title-holder">
                            <h1 className="title success-title"><b>You are in!</b></h1>
                        </div>
                        <div className="subtitle-holder">
                            <h3 className="subtitle success-subtitle">Your spot in the waitlist is reserved.</h3>
                        </div>
                        <div className="waitlist-actions-holder">
                            <div className="waitlist-button-holder">
                                <button className="waitlist-exit-button waitlist-button" onClick={handleExitWaitlist}>Leave the waitlist<i className="fas fa-angle-right"/></button>
                            </div>
                            <div className="howitworks-button-holder">
                                <button className="howitworks-exit-button howitworks-button" onClick={handleHowItWorks}>How it works?</button>
                            </div>
                        </div>
                    </div>
                }

            </div>
        </div>
    )
};